var map = {
	"./en/accounts.json": 80595,
	"./en/auto_dj.json": 33879,
	"./en/default.json": 85672,
	"./en/episodes.json": 76805,
	"./en/fields.json": 22442,
	"./en/podcasts.json": 44270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84405;